const PANORAMIC =
  "https://images.unsplash.com/photo-1459908676235-d5f02a50184b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxhcnRpc3QlMjBzdHVkaW8lMjBwYWludGluZyUyMHBhbm9yYW1hfGVufDB8fHx8MTc5MTc4MTg2MXww&ixlib=rb-4.1.0&q=85";

export default function ArtBand() {
  return (
    <section className="relative w-full h-80 overflow-hidden border-b border-line">
      <img
        src={PANORAMIC}
        alt="Wide horizon abstract canvas in progress at the studio"
        className="absolute inset-0 w-full h-full object-cover opacity-40 art-drift"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ground/60 to-ground" />
      <div className="relative max-w-6xl mx-auto px-6 h-full flex items-center justify-between">
        <div>
          <span className="mono-tag text-xs text-gold uppercase tracking-widest block mb-1">
            Scale &amp; Palette
          </span>
          <h3 className="text-2xl md:text-4xl font-bold uppercase text-white">
            Custom Sizes up to 12 Feet
          </h3>
        </div>
        <a
          href="#commissions"
          className="hidden sm:inline-block px-5 py-3 border border-white text-white text-xs font-bold uppercase tracking-wider hover:bg-white hover:text-black transition-colors"
          data-testid="artband-sizing-guide-btn"
        >
          Commission Sizing Guide
        </a>
      </div>
    </section>
  );
}
